import React from 'react';
import { links } from '../data/site';
import { trackEvent } from '../utils/analytics';
export function Footer() {
  return <footer className="bg-paper border-t border-rule" data-id="element-50" data-mp="3gg0yw2enzvx4">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10 pt-10 pb-24 sm:pb-10 flex flex-col md:flex-row md:items-center md:justify-between gap-5" data-id="element-51" data-mp="32o4bgbnxya72">
        <p className="text-sm text-ink-soft" data-id="element-52" data-mp="36pzebklisvmy">
          <span className="font-serif text-base text-ink" data-id="element-53" data-mp="3ufa64ckw7foy">Thomas Consulting</span>
          <span className="text-ink-mute" data-id="element-54" data-mp="38qw2zmvrtrp"> · Craig Thomas · Portland, Oregon</span>
        </p>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm" data-id="element-55" data-mp="36d26u3xsnlq">
          <a href={links.linkedin} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('linkedin_click')} className="font-medium text-forest hover:text-forest-soft transition-colors duration-200" data-id="element-56" data-mp="3le2l2w7e0bct">
            Connect on LinkedIn
            <span className="sr-only" data-id="element-57" data-mp="2evxa0y3czd0s"> (opens in a new tab)</span>
          </a>
          <a href={links.magicPatterns} target="_blank" rel="noopener noreferrer" className="text-ink-mute hover:text-forest transition-colors duration-200" data-id="element-58" data-mp="3l9shh1e8ymmw">
            Built with Magic Patterns
            <span className="sr-only" data-id="element-59" data-mp="3q8dk17gz1iei"> (opens in a new tab)</span>
          </a>
        </div>
      </div>
    </footer>;
}